import { Link } from "react-router-dom";
import { Wallet } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { fmt, fileUrl } from "@/lib/api";

export const Logo = () => {
  const ctx = useAuth();
  return (
    <span className="text-[26px] font-black italic tracking-tight leading-none select-none" data-testid="site-logo">
      {ctx?.site?.site_name || "XVER"}
    </span>
  );
};

export const Avatar = ({ user, size = 36 }) =>
  user?.avatar_path ? (
    <img src={fileUrl(user.avatar_path)} alt="" style={{ width: size, height: size }} className="rounded-full object-cover" />
  ) : (
    <div
      style={{ width: size, height: size, fontSize: size * 0.42 }}
      className="rounded-full bg-[var(--x-blue)] flex items-center justify-center font-extrabold uppercase"
    >
      {user?.username?.[0] || "?"}
    </div>
  );

export const Header = () => {
  const { user, openAuth, setWalletOpen } = useAuth();
  return (
    <header className="sticky top-0 z-40 bg-[var(--x-bg)]/95 backdrop-blur-md border-b border-black/30 shadow-[0_4px_12px_-6px_rgba(0,0,0,.6)]">
      <div className="max-w-6xl mx-auto h-16 px-4 flex items-center justify-between gap-3">
        <Link to="/" data-testid="header-home-link">
          <Logo />
        </Link>
        {user ? (
          <div className="flex items-center gap-2">
            <div className="flex items-stretch rounded-md overflow-hidden">
              <div data-testid="header-balance" className="bg-[var(--x-bg-deep)] px-3 sm:px-4 flex items-center gap-1.5 font-bold text-[15px] tabular-nums">
                <span className="text-[var(--x-muted)]">₺</span>
                {fmt(user.balance)}
              </div>
              <button data-testid="header-wallet-btn" onClick={() => setWalletOpen(true)} className="x-btn x-btn-primary rounded-none px-3 sm:px-4 py-2.5">
                <Wallet size={18} />
                <span className="hidden sm:inline">Cüzdan</span>
              </button>
            </div>
            <Link to="/profil" data-testid="header-profile-link" className="hidden sm:block">
              <Avatar user={user} />
            </Link>
          </div>
        ) : (
          <div className="flex items-center gap-2">
            <button data-testid="header-login-btn" onClick={() => openAuth("login")} className="x-btn px-4 py-2.5 hover:bg-white/5">
              Giriş Yap
            </button>
            <button data-testid="header-register-btn" onClick={() => openAuth("register")} className="x-btn x-btn-primary px-4 py-2.5">
              Kayıt Ol
            </button>
          </div>
        )}
      </div>
    </header>
  );
};
